import styled from 'styled-components';
import { FaInstagram, FaFacebook, FaLinkedin, FaTwitter } from 'react-icons/fa';
import { panelDeep, borderSoft, mono, accent } from '../../styles/techComponents';

export const PLATFORMS = [
  { id: 'x', label: 'X / Twitter', Icon: FaTwitter, color: '#1DA1F2' },
  { id: 'instagram', label: 'Instagram', Icon: FaInstagram, color: '#E1306C' },
  { id: 'linkedin', label: 'LinkedIn', Icon: FaLinkedin, color: '#0A66C2' },
  { id: 'facebook', label: 'Facebook', Icon: FaFacebook, color: '#1877F2' },
];

export const FRECUENCIAS = [
  { value: 'bajo', label: 'Bajo (1 post/dia)' },
  { value: 'medio', label: 'Medio (2-3 posts/dia)' },
  { value: 'alto', label: 'Alto (4+ posts/dia)' },
];

export const INTERESES_PREDEFINIDOS = [
  'Crypto', 'Marketing', 'Deportes', 'Tecnologia', 'Politica',
  'Finanzas', 'Startups', 'IA', 'Gaming', 'Moda', 'Musica',
  'Cine', 'Fitness', 'Viajes', 'Comida', 'Ciencia', 'Arte',
  'Fotografia', 'Literatura', 'Medio Ambiente',
];

export const ZONAS_HORARIAS = [
  'America/Argentina/Buenos_Aires', 'America/Santiago', 'America/Lima',
  'America/Bogota', 'America/Mexico_City', 'America/New_York',
  'America/Los_Angeles', 'Europe/Madrid', 'Europe/London',
];

export const STATUS_META = {
  inactive: { color: 'var(--text-disabled)', label: 'Inactivo' },
  verificando: { color: 'var(--alert-warning, #f59e0b)', label: 'Verificando...' },
  active: { color: 'var(--alert-success, #38d39f)', label: 'Activo / Listo' },
  failed: { color: 'var(--alert-error, #ff5470)', label: 'Fallo' },
  banned: { color: 'var(--alert-error, #ff5470)', label: 'Baneado' },
  challenge_required: { color: 'var(--alert-warning, #f59e0b)', label: 'Requiere verificacion' },
};

export const GREEN = 'var(--alert-success, #38d39f)';
export const RED = 'var(--alert-error, #ff5470)';

export const TwoCol = styled.div`
  display: grid; grid-template-columns: 1fr 1fr; gap: 1.25rem;
  @media (max-width: 900px) { grid-template-columns: 1fr; }
`;

export const ThreeCol = styled.div`
  display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 1.25rem;
  @media (max-width: 1100px) { grid-template-columns: 1fr 1fr; }
  @media (max-width: 700px) { grid-template-columns: 1fr; }
`;

export const FormRow = styled.div`
  display: flex; flex-direction: column; gap: 0.35rem;
`;

export const Label = styled.label`
  font-family: ${mono}; font-size: 0.62rem; letter-spacing: 0.16em;
  text-transform: uppercase; color: var(--text-disabled);
`;

export const Hint = styled.span`
  font-family: ${mono}; font-size: 0.6rem; color: var(--text-disabled); margin-top: 2px;
`;

export const TagsGrid = styled.div`
  display: flex; flex-wrap: wrap; gap: 0.4rem;
`;

export const Tag = styled.button`
  display: inline-flex; align-items: center; gap: 0.3rem;
  padding: 0.3rem 0.65rem; font-family: ${mono}; font-size: 0.72rem;
  color: ${(p) => p.$active ? '#fff' : 'var(--text-secondary)'};
  background: ${(p) => p.$active ? 'rgba(0, 180, 216, 0.2)' : panelDeep};
  border: 1px solid ${(p) => p.$active ? 'rgba(0, 180, 216, 0.45)' : borderSoft};
  border-radius: 4px; cursor: pointer; transition: all 0.15s ease;
  &:hover {
    border-color: rgba(0, 180, 216, 0.4);
    background: rgba(0, 180, 216, 0.1);
  }
  &::before {
    content: '#';
    color: ${(p) => p.$active ? accent : 'var(--text-disabled)'};
    font-weight: 600;
  }
`;

export const SliderContainer = styled.div`
  display: flex; align-items: center; gap: 0.75rem;
`;

export const Slider = styled.input`
  flex: 1; -webkit-appearance: none; height: 6px; border-radius: 3px;
  background: ${panelDeep}; border: 1px solid ${borderSoft}; outline: none;
  &::-webkit-slider-thumb {
    -webkit-appearance: none; width: 18px; height: 18px; border-radius: 50%;
    background: ${accent}; cursor: pointer; border: 2px solid rgba(0, 180, 216, 0.3);
  }
`;

export const SliderValue = styled.span`
  font-family: ${mono}; font-size: 0.85rem; font-weight: 600;
  color: ${accent}; min-width: 42px; text-align: right;
`;

export const ProfileCard = styled.div`
  display: flex; flex-direction: column; gap: 0.6rem;
  padding: 1rem 1.1rem; background: ${panelDeep};
  border: 1px solid ${(p) => p.$borderColor || borderSoft};
  border-left: 4px solid ${(p) => p.$accentColor || accent};
  border-radius: 8px;
`;

export const ProfileHeader = styled.div`
  display: flex; align-items: center; gap: 0.7rem;
  .icon {
    width: 38px; height: 38px; border-radius: 8px;
    background: rgba(255,255,255,0.05);
    color: ${(p) => p.$iconColor || accent};
    display: inline-flex; align-items: center; justify-content: center;
    font-size: 1.1rem; flex-shrink: 0;
  }
  .info { flex: 1; min-width: 0; }
  .info h4 { margin: 0; font-size: 0.9rem; color: var(--text-primary); font-weight: 600; }
  .info .sub {
    font-family: ${mono}; font-size: 0.62rem; letter-spacing: 0.14em;
    color: var(--text-disabled); text-transform: uppercase;
  }
`;

export const StatusDot = styled.span`
  display: inline-block; width: 9px; height: 9px; border-radius: 50%;
  background: ${(p) => p.$color || 'gray'};
  box-shadow: 0 0 0 3px ${(p) => (p.$color || 'gray')}33;
`;

export const ProfileActions = styled.div`
  display: flex; gap: 0.5rem; padding-top: 0.4rem;
  border-top: 1px solid ${borderSoft};
`;

export const Banner = styled.div`
  padding: 0.7rem 0.9rem; border-radius: 6px;
  font-size: 0.82rem; line-height: 1.5; margin-top: 0.5rem;
  background: ${(p) => p.$ok ? 'rgba(56, 211, 159, 0.08)' : 'rgba(239, 71, 111, 0.08)'};
  border: 1px solid ${(p) => p.$ok ? 'rgba(56, 211, 159, 0.3)' : 'rgba(239, 71, 111, 0.3)'};
  border-left: 3px solid ${(p) => p.$ok ? GREEN : RED};
  color: ${(p) => p.$ok ? GREEN : RED};
`;

export const BatchResults = styled.div`
  margin-top: 0.75rem; font-family: ${mono}; font-size: 0.78rem;
  color: var(--text-secondary); line-height: 1.6;
  .ok { color: ${GREEN}; }
  .err { color: ${RED}; }
`;

export const FileDropZone = styled.div`
  border: 2px dashed ${borderSoft}; border-radius: 8px;
  padding: 1.5rem; text-align: center; cursor: pointer;
  transition: border-color 0.18s ease, background 0.18s ease;
  color: var(--text-disabled); font-size: 0.85rem;
  &:hover {
    border-color: rgba(0, 180, 216, 0.4);
    background: rgba(0, 180, 216, 0.04);
    color: var(--text-secondary);
  }
  svg { font-size: 1.5rem; margin-bottom: 0.4rem; color: ${accent}; }
`;
